const dbNews = {
  table: 'News',
  where: [
    ['PublishDate__c','<','2022']
  ],
  order: [
    ['PublishDate__c','asc']
  ]
}

export default dbNews;